import React, { useState, useCallback, useMemo } from 'react';
import { Select, DatePicker} from 'antd';

const { RangePicker } = DatePicker;

const FilterDays = ({ defaultValue, items, handleChange }) => {
  const [selectedItem, setSelectedItem] = useState(defaultValue);
  const [selectedValue, setSelectedValue] = useState(defaultValue);

  const options = Array.isArray(items) ? items.map((item) => ({
    label: item.label,
    value: item.value, 
  })) : [];

  const handleRangeChange = (dates) => {
    if (dates) {
      // const [start, end] = dates;
      // const diffInDays = end.diff(start, 'days') + 1; // +1 to include both start and end days
      setSelectedValue(dates);
      handleChange(dates); // Pass the new range in days back to the parent
    } 
  };

  const handleSelectChange = (value) => {
    setSelectedValue(value);
    setSelectedItem(value)
    handleChange(parseInt(value, 10)); // Ensure the value is passed as a number
  };

  //  const options = useMemo(() => 
  //   Array.isArray(items) ? items.map((item) => ({
  //     label: item.label,
  //     value: item.value,
  //   })) : [],
  // [items]);

  // const handleRangeChange = useCallback((dates) => {
  //   if (dates) {
  //     setSelectedValue(dates);
  //     handleChange(dates);
  //   }
  // }, [handleChange]);

  // const handleSelectChange = useCallback((value) => {
  //   setSelectedValue(value);
  //   setSelectedItem(value);
  //   handleChange(parseInt(value, 10));
  // }, [handleChange]);

  return (
    <div style={{display: "flex", justifyContent: "center"}}>
      {selectedItem === 'custom' ? (
        <RangePicker style={{width: "180px"}} onChange={handleRangeChange}/>
      ) : (
      <Select
        style={{ width: 180, marginRight: "5px" }}
        defaultValue={selectedValue}
        options={options}
        onChange={handleSelectChange}
      />
      )}
    </div>
  );
};

export default FilterDays;
